import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { UserSession } from '../models/usersession';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class UserSessionService {
  session = new UserSession();
  localStorageSessionKey: string;
  filterArr: any[];
  private readonly storageSecret: string = 'N00l4g4m_LMIS_S3cur1ty_K3y_@2026#Xts!';

  constructor() {
    this.localStorageSessionKey = 'eGramam-' + environment.apiBaseUrl + '-AuthData';
  }

  /**
   * AES-256 Encrypts any data payload before storing into browser storage
   */
  private encryptData(data: any): string {
    if (data === null || data === undefined) return '';
    try {
      const str = typeof data === 'string' ? data : JSON.stringify(data);
      return CryptoJS.AES.encrypt(str, this.storageSecret).toString();
    } catch (e) {
      return '';
    }
  }

  /**
   * Decrypts AES-256 ciphertext from browser storage.
   * Handles backward compatibility if raw JSON is encountered.
   */
  private decryptData(cipherText: string): any {
    if (!cipherText) return null;
    const trimmed = cipherText.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        return JSON.parse(trimmed);
      } catch (e) { }
    }
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.storageSecret);
      const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedStr) return null;
      try {
        return JSON.parse(decryptedStr);
      } catch {
        return decryptedStr;
      }
    } catch (e) {
      return null;
    }
  }

  /**
   * Centralized accessor to safely decrypt authenticated user session
   */
  private getSessionData(): any {
    const raw = localStorage.getItem(this.localStorageSessionKey);
    return this.decryptData(raw);
  }

  create(session: any) {
    this.setLocalStorageProperties(session);
  }

  destroy() {
    this.setLocalStorageProperties(new UserSession());
    localStorage.removeItem('role');
    localStorage.removeItem('isLoggedin');
    localStorage.clear();
    sessionStorage.clear();
  }

  load() {
    const data = this.getSessionData();
    return data ? (typeof data === 'string' ? data : JSON.stringify(data)) : null;
  }

  authToken(): any {
    const data = this.getSessionData();
    return data && data.authToken ? data.authToken : '';
  }

  userId(): number {
    const data = this.getSessionData();
    return data && data.userId ? +data.userId : 0;
  }

  getUserName(): any {
    const data = this.getSessionData();
    return data && data.userFullName ? data.userFullName : '';
  }

  roleId(): any {
    const data = this.getSessionData();
    return data && data.roleId ? +data.roleId : 0;
  }

  roleName(): any {
    const data = this.getSessionData();
    return data && data.roleName ? data.roleName : '';
  }

  getFilterregionId() {
    const data = this.getSessionData();
    return data && data.filterregionId ? data.filterregionId : [];
  }

  getFilterDivisionId() {
    const data = this.getSessionData();
    return data && data.filterdivisionId ? data.filterdivisionId : [];
  }

  getFilterSubDivisionId() {
    const data = this.getSessionData();
    return data && data.filtersubdivisionId ? data.filtersubdivisionId : [];
  }

  getRegionId() {
    const data = this.getSessionData();
    return data && data.regionId ? data.regionId : [];
  }

  getDivisionId() {
    const data = this.getSessionData();
    return data && data.divisionId ? data.divisionId : [];
  }

  getSubDivisionId() {
    const data = this.getSessionData();
    return data && data.subDivisionId ? data.subDivisionId : [];
  }

  getCurrentSubDivisionId() {
    const data = this.getSessionData();
    return data && data.currentSubDivisionId ? data.currentSubDivisionId : [];
  }

  getClientId() {
    const data = this.getSessionData();
    return data && data.clientId ? data.clientId : [];
  }

  getCurrentClientId() {
    const data = this.getSessionData();
    return data && data.currentClientId ? data.currentClientId : [];
  }

  getCurrentClientName() {
    const data = this.getSessionData();
    return data && data.currentClientName ? data.currentClientName : [];
  }

  getEmail() {
    const data = this.getSessionData();
    return data && data.email ? data.email : [];
  }

  getLibrary() {
    const data = this.getSessionData();
    return data && data.Libraryid ? data.Libraryid : [];
  }

  getLanguageType() {
    const data = this.getSessionData();
    return data && data.languageType ? data.languageType : [];
  }

  referrence2() {
    const data = this.getSessionData();
    if (!data || !data.departmentId) return null;
    const dept = typeof data.departmentId === 'string' ? JSON.parse(data.departmentId) : data.departmentId;
    return dept ? dept.Services : null;
  }

  setLocalStorageProperties(session: any) {
    if (!session) {
      localStorage.removeItem(this.localStorageSessionKey);
      return;
    }
    const cipher = this.encryptData(session);
    localStorage.setItem(this.localStorageSessionKey, cipher);
  }

  getLocalStorageWithKey(key: any) {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const decrypted = this.decryptData(raw);
    return typeof decrypted === 'object' ? JSON.stringify(decrypted) : decrypted;
  }

  setLocalStorageWithKey(key: any, session: any) {
    if (session === null || session === undefined) {
      localStorage.removeItem(key);
      return;
    }
    const cipher = this.encryptData(session);
    localStorage.setItem(key, cipher);
  }

  isDynamicPassword() {
    const data = this.getSessionData();
    return data == null ? '' : data;
  }

  getPageUrl(key: any) {
    debugger
    this.filterArr = [];
    const menuRaw = this.getLocalStorageWithKey('menucontrols');
    if (!menuRaw) return false;
    const menu = typeof menuRaw === 'string' ? JSON.parse(menuRaw) : menuRaw;
    if (!menu || !Array.isArray(menu)) return false;
    menu.forEach(e => {
      if (e.submenu && Array.isArray(e.submenu)) {
        e.submenu.forEach(element => {
          this.filterArr.push(element);
        });
      }
    });
    const output = this.filterArr.find(e => e.path === key);
    return output ? output.controlAccess : false;
  }

  getDistrictId() {
    const data = this.getSessionData();
    return data == null ? [] : data.districtId;
  }

  getTalukId() {
    const data = this.getSessionData();
    return data == null ? [] : data.talukId;
  }

  getVillageId() {
    const data = this.getSessionData();
    return data == null ? [] : data.villagepanchayatId;
  }

  getBlockId() {
    const data = this.getSessionData();
    return data == null ? [] : data.blockId;
  }

  getFilterDistrictId() {
    const data = this.getSessionData();
    return data == null ? [] : data.filterdistrictId;
  }

  getFilterBlockId() {
    const data = this.getSessionData();
    return data == null ? [] : data.filterblockId;
  }

  getFilterDate() {
    const data = this.getSessionData();
    return data == null ? [] : data.filterdate;
  }
}
